import React, { Component } from "react";

class FloorsStrip extends Component {

  getStyle(index, current, start){
    let selectedStyle = {
      fontSize: `${35}px`,
      color: "#e5104d",
      //backgroundColor: "rgba(195, 202, 208, 0.5)",
      borderRadius: "15px",
      paddingLeft: "15px",
      paddingRight: "15px",
      marginRight: "0px",
      marginLeft: "0px",
      border: "3px solid"
    }

    let unselectedStyle = {
      fontSize: `${15}px`,
      color: "#6c757d",
      marginRight: "15px",
      marginLeft: "15px"
    }

    let startingStyle = {
      fontSize: `${22}px`,
      color: "#e5104d",
      marginRight: "15px",
      marginLeft: "15px"
    }

    if(index !== current && index !== start)
      return unselectedStyle;
    if(index === current)
      return selectedStyle;
    if(index !== current && index === start)
      return startingStyle;
  }

  render() {
    let { selected, start, pm1, p0, p1, p2, p3, p4 } = this.props;
    let startFloor = 0;
    if(start.store_info)
      startFloor = parseInt(start.store_info.nivel, 10);

    let labelStyle = {
      fontSize: `${16}px`,
      color: "#6c757d",
      marginRight: "15px"
    }
    
    return (
      <div className="floors-strip-container">
        <div style= {labelStyle}>Nivel:</div>
        { pm1.length > 0 ? 
        (<div style={ this.getStyle(-1, selected, startFloor) }> -1</div>)
        : false
        }
        { p0.length > 0 ? 
        (<div style={ this.getStyle(0, selected, startFloor) }> 0</div>)
        : false
        }
        { p1.length > 0 ? 
        (<div style={ this.getStyle(1, selected, startFloor) }> 1</div>)
        : false
        }
        { p2.length > 0 ? 
        (<div style={ this.getStyle(2, selected, startFloor) }> 2</div> )
        : false
        }
        { p3.length > 0 ? 
        (<div style={ this.getStyle(3, selected, startFloor) }> 3</div>)
        : false
        }
        { p4.length > 0 ? 
        (<div style={ this.getStyle(4, selected, startFloor) }> 4</div>)
        : false
        }
     </div>
    )
  }
}

export default FloorsStrip;



// WEBPACK FOOTER //
// ./src/views/FloorsStrip.js